import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom-v5-compat';

import { useIsAdmin } from '@/modules/auth/hooks/useIsAdmin';

import { legacyAdminSplitLayoutRoutes, legacySplitLayoutRoutes } from '../../../constants';

export const useIsLegacySplitLayoutRoute = () => {
    const location = useLocation();
    const isAdmin = useIsAdmin();

    return useMemo(() => {
        const routes = isAdmin ? [...legacySplitLayoutRoutes, ...legacyAdminSplitLayoutRoutes] : legacySplitLayoutRoutes;

        return Boolean(matchRoutes(routes, location));
    }, [isAdmin, location]);
};
